<!--
@Description: 按钮组
@Author: 吳廣帥
@Date:2022/1/5 - 14:10
@Name:buttonGroup
@Version:v1.0
-->
<style scoped lang="less">
/** 最外层div盒子*/
.buttonGroup-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  &__label{
    &__circle{
      display: inline-flex;
      width: .16rem;
      height: .16rem;
      background: #2877ff;
      border-radius: 50%;
    }
    &__text{
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4A4A4A;
      line-height: 0.28rem;
      margin-left: 0.18rem;
      display: inline-flex;
    }
  }
  &__button-group{
    display: flex;
    flex-direction: row;
    &__button{
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4A4A4A;
      line-height: 0.24rem;
      margin-left: .24rem;
    }
  }
}
.active{
  color: #2877FF;
}
</style>
<template>
  <!--  组件最外层盒子-->
  <div class="buttonGroup-box">
    <div class="buttonGroup-box__label">
      <span class="buttonGroup-box__label__circle" />
      <span class="buttonGroup-box__label__text" v-if="$props.label">{{ label }}</span>
    </div>
    <div class="buttonGroup-box__button-group">
      <div class="buttonGroup-box__button-group__button" :class="{ 'active': $props.value === item.key }" v-for="(item,index) of $props.buttonGroup" :key="item.key" @click="clickButton(item)">{{ item.label }}</div>
    </div>
  </div>
</template>
<script>

export default {
  /** 方法区 **/
  methods: {
    clickButton(item){
      if(this.$props.disabled) return this.$emit('disabled')
      this.$emit('input',item.key)
    }
  },
  /** 数据区 **/
  props: {
    buttonGroup:{ type:Array, default: () => ([]) },
    label: { type:String },
    value: { type:String },
    disabled: { type:Boolean }
  },
}
</script>








